document.addEventListener('DOMContentLoaded', function() {
  // This javascript file is used to the calculation of the "Dimensionering af regnvandsanlæg" page.

  function calculateRegnvand() {
    // Input variables:
    let forbrugsdage = 250; // Fixed value
    let personer = parseFloat(document.getElementById('personer').value) || 0;
    let vaskemaskine = parseFloat(document.querySelector('#vaskemaskine').value) || 0;
    let wc = parseFloat(document.querySelector('#wc').value) || 0;
    let havevanding = parseFloat(document.querySelector('#havevanding').value) || 0;
    
    let tagareal = parseFloat(document.getElementById('tagareal').value) || 0;
    let taghaeldning = parseFloat(document.getElementById('taghaeldning').value) || 0;
    let nedboer = parseFloat(document.getElementById('nedboer').value) || 0;
    let tagmateriale = parseFloat(document.getElementById('tagmateriale').value) || 0;
    let reduktion = 0.9; // Fixed value
    
    if (!personer || !tagareal) {
      alert('Udfyld venligst både antal personer og tagareal.');
      return;
    }

    // Total output calculation
    let vaskemaskine_forbrug = (vaskemaskine * personer) * forbrugsdage; // in liters per year
    let wc_forbrug = (wc * personer) * forbrugsdage; // in liters per year
    let samlet_forbrug = vaskemaskine_forbrug + wc_forbrug + havevanding; // in liters per year
    let Vforbrug = 0.06 * samlet_forbrug; // in liter

    let afstroemningstal;
    if (taghaeldning === 0) {
      afstroemningstal = tagmateriale - 0.45;
    } else if (taghaeldning === 5) {
      afstroemningstal = tagmateriale - 0.4;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 10) {
      afstroemningstal = tagmateriale - 0.35;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 15) {
      afstroemningstal = tagmateriale - 0.3;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 20) {
      afstroemningstal = tagmateriale - 0.25;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 25) {
      afstroemningstal = tagmateriale - 0.2;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 30) {
      afstroemningstal = tagmateriale - 0.15;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 35) {
      afstroemningstal = tagmateriale - 0.1;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 40) {
      afstroemningstal = tagmateriale - 0.05;
      if (afstroemningstal < 0) { afstroemningstal = 0; }
    } else if (taghaeldning === 45) {
      afstroemningstal = tagmateriale;
    } else if (taghaeldning === 50) {
      afstroemningstal = tagmateriale + 0.05;
    } else if (taghaeldning === 55) {
      afstroemningstal = tagmateriale + 0.1;
    } else if (taghaeldning === 60) {
      afstroemningstal = tagmateriale + 0.15;
    } else if (taghaeldning === 65) {
      afstroemningstal = tagmateriale + 0.2;
    } else if (taghaeldning === 70) {
      afstroemningstal = tagmateriale + 0.25;
    } else if (taghaeldning === 75) {
      afstroemningstal = tagmateriale + 0.3;
    }
    console.log('Debug Vtag calculation:');
    console.log('tagareal:', tagareal);
    console.log('nedboer:', nedboer);
    console.log('afstroemningstal:', afstroemningstal);
    console.log('reduktion:', reduktion);
    console.log('Multiplication factor:', 0.06);
    let Vtag = tagareal * nedboer * afstroemningstal * reduktion * 0.06; // in liter
    console.log('Vtag result:', Vtag);

    let Vanbefalet;
    if (Vforbrug > Vtag) {
      Vanbefalet = Vtag * 1.1; // in m3
    } else if (Vtag >= Vforbrug) {
      Vanbefalet = Vforbrug * 1.1; // in m3
    }
    
    // Defining output variables
    let outputOne = document.querySelector('#total-output-one');
    let outputTwo = document.querySelector('#total-output-two');
    let outputThree = document.querySelector('#total-output-three');

    // Showing output calculations
    if (outputOne) {
      outputOne.textContent = Vforbrug.toFixed(0) + ' L';
    }
    let qudNS;
    if (outputTwo) {
      if (Vanbefalet > 0 && Vanbefalet <= 1200) {
        qudNS = '1200';
      } else if (Vanbefalet > 1200 && Vanbefalet <= 2500) {
        qudNS = '2500';
      } else if (Vanbefalet > 2500 && Vanbefalet <= 3300) {
        qudNS = '3300';
      } else if (Vanbefalet > 3300 && Vanbefalet <= 4300) {
        qudNS = '4300';
      } else if (Vanbefalet > 4300 && Vanbefalet <= 5000) {
        qudNS = '5000';
      } else if (Vanbefalet > 5000 && Vanbefalet <= 7000) {
        qudNS = '7000';
      } else if (Vanbefalet > 7000 && Vanbefalet <= 10000) {
        qudNS = '10000';
      } else if (Vanbefalet > 10000) {
        qudNS = 'Speciallavet';
      }
      outputTwo.textContent = Vtag.toFixed(0) + ' L';
    }
    if (outputThree) {
      outputThree.textContent = Vanbefalet.toFixed(0) + ' L';
    }

    // Product recommendation from calculation
    let products = document.querySelectorAll('.product-recommendation-item');
    if (vaskemaskine === 0 && wc === 0) {
      products = document.querySelectorAll('.product-recommendation-item_fallback');
    }
    let fallbackProduct = document.querySelector('.no-product-recommendation-item');

    let bestProduct = null;
    let bestInterval = Infinity; // Start with Infinity since we want the lowest intervalValue above qud

    products.forEach(function(product, idx) {
      product.classList.forEach(function(className) {
        let match = className.match(/^interval-(\d+)$/);
        if (match) {
          let intervalValue = parseInt(match[1], 10);
          console.log(`Product #${idx} class: ${className}, intervalValue: ${intervalValue}`);
          if (intervalValue >= qudNS && intervalValue < bestInterval) {
            bestInterval = intervalValue;
            bestProduct = product;
            console.log(`--> New bestProduct found: Product #${idx} with intervalValue ${intervalValue}`);
          }
        }
      });
    });

    console.log('Best interval found:', bestInterval);
    console.log('Best product:', bestProduct);

    // Hide all products first using the 'hidden' class
    products.forEach(function(product) {
      product.classList.add('hidden');
      product.classList.remove('chosen');
    });
    if (fallbackProduct) {
      fallbackProduct.classList.add('hidden');
      fallbackProduct.classList.remove('chosen');
    }

    // Show the best matching product, or fallback if none found
    if (bestProduct) {
      console.log('Showing bestProduct');
      bestProduct.classList.remove('hidden');
      bestProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    } else if (fallbackProduct) {
      console.log('Showing fallbackProduct');
      fallbackProduct.classList.remove('hidden');
      fallbackProduct.classList.add('chosen');
      let sendButton = document.querySelector('.custom-send-formula-button');
      if (sendButton) {
        sendButton.classList.add('active');
      }
    }

  }

  let submitButton = document.querySelector('#submit-calculation-regnvand');
  if (submitButton) {
    submitButton.addEventListener('click', function(event) {
      event.preventDefault();
      calculateRegnvand();
    });
  }

});